import { RelativeScaleIcon } from './RelativeScaleIcon';

/**
 * author: Google
 * id 912AD329-9B77-4959-9407-0F64BABFAC7D
 * name relative-scale
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/relative-scale.svg
 * tags
 */
export const ImageAspectRatioIcon = RelativeScaleIcon;
export default ImageAspectRatioIcon